<template>
    <div class="loadingbox">
      <div class=" loader_bg">
        <iframe
            :src="`https://www.cruisereizen.nl/swimturtle`"
            width="100%"
            height="200"
            frameborder="0" >
        </iframe>
      </div>
      <p style="margin-top:-50px;">{{randomMessage}}</p>
    </div>
</template>

<script>
import { library } from '@fortawesome/fontawesome-svg-core'
import { faMinus, faPlane, faPlus } from '@fortawesome/free-solid-svg-icons'

library.add(faPlane)
library.add(faPlus)
library.add(faMinus)

export default {
    name: 'StepLoading',
  data: function() {
    return {
      randomMessage: 'Één, twee, drie, vier. Hoedje van papier.'
    }
    },

  mounted(){
    window.setInterval(()=>{
      this.getRandom();
    }, 2800);

  },
  methods: {
    getRandom(){
      var randomMessages = [
        'Het is de allermooiste boot van allemaal.',
        'Berend botje ging uit varen.',
        'Ik heb een hele mooie splinternieuwe boot.',
        'Schipper mag ik overvaren, ja of nee?',
        'Row, row, row your boat',
        'Met zijn schip de Scheve Schuit vaart hij alle dagen uit',
      ]

      this.randomMessage = randomMessages[Math.floor(Math.random() * randomMessages.length)]
    }
  }
}
</script>


<style lang="scss">
.loadingbox {
  color: #b7daf2;
  position:absolute;
  top:0;
  left:0;
  right:0;
  bottom:0;
  z-index:10000;
  text-align: center;
  display:flex;
  flex-flow:column;
  justify-content: center;
  pointer-events: none;
  p {
    font-size: 24px;
    color: #2178b3;
  }
}
</style>